import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueCompositionAPI from '@vue/composition-api'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import mitt from 'mitt'
import VueRouterUserRoles from 'vue-router-user-roles'
import Toasted from 'vue-toasted'
import VueOptionsList from 'vue-options-list'
import DashboardPlugin from '@plugins/dashboard-plugin'
import App from '@/App.vue'

import router from '@/router.js'
import store from '@store'
import eventBus from '@events'
import { SetupInterceptors } from '@services'

import { titleMixin as title } from '@mixins'

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALYTICS_ID,
  router
})
Vue.use(VueCompositionAPI)
Vue.use(VueMoment, {
  moment
})
Vue.use(VueRouterUserRoles, {
  router
})
Vue.use(Toasted, {
  router,
  theme: 'toasted-primary',
  type: 'success',
  position: 'bottom-center',
  duration: 3000,
  singleton: true
})
Vue.use(VueOptionsList)
Vue.use(DashboardPlugin)

Vue.mixin(title)

Vue.prototype.$emitter = mitt()
Vue.prototype.$bus = eventBus
Vue.prototype.$user.set(
  Object.assign(store.getters.user, {
    role: store.getters.user.is_superuser
      ? 'Superuser'
      : store.getters.user.type
  })
)

SetupInterceptors(store)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App),
  data() {
    return {
      dashboard_report: null
    }
  },
  store,
  router
})
